export const parseDomainFromEmail = (email: string) => {
  let emailDomain = '';
  if (email.indexOf('@') !== -1) {
    emailDomain = email.split('@')[1];
  }
  return emailDomain;
};
